import api from "config/api"
import { Notification } from "notification/notification";


export const getAllPermission = async () => {
    try {
        const { data } = await api.get("permission/v1/show");
        return data;
    } catch (err) {
        Notification(500)
    }
};

export const createPermissionUser = async (id, permission) => {
    try {
        const { status } = await api.post("permission/v1/create", { userId: id, roles: [permission.namePermission] });
        return status;
    } catch (err) {
        Notification(500)
    }
};


export const removePermissionUser = async (id, permission) => {
    try {
        const { status } = await api.post("permission/v1/remove", { userId: id, roles: [permission] });
        return status;
    } catch (err) {
        Notification(500)
    }
};

